const UPDATE = 'SELECT_UPDATE';

export {
  UPDATE, // eslint-disable-line
};



// WEBPACK FOOTER //
// ./src/data/states/select.js